import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { reportScopes } from "@/mocks/site";

const bubbleStyles = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-800",
  "bg-background-200 text-foreground-800",
];

export default function ScopesSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="受理范围"
            title="四类直播争议，都在受理范围内"
            description="无论是画面突然中断、主播违规引导，还是打赏与抽奖的消费争议、素材与翻唱的版权问题，都可以在这里提交线索，进入统一的核查流程。"
          />
          <Link
            to="/report"
            className="mt-7 inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-medium bg-foreground-950 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            查看举报须知
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {reportScopes.map((scope, index) => (
            <article
              key={scope.title}
              className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 transition-colors hover:border-primary-300"
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-lg ${bubbleStyles[index % bubbleStyles.length]}`}
              >
                <i className={`${scope.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{scope.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{scope.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}